import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { KeywordPaneInfoTooltip } from './KeywordPaneInfoTooltip';

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
`;

const HeaderText = styled.div`
  font-size: 14px;
  text-align: right;
  color: ${props => (props.isExceeded ? '#ff4d4f' : '#333')};
  font-weight: ${props => (props.isExceeded ? 'bold' : 'normal')};
`;

const HeaderTextParagraph = styled.p`
  margin: 0;
`;
const HeaderTextParagraphWarning = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: normal;
`;

export const KeywordPaneHeader = props => {
  if (!props.keywordCount) {
    return <KeywordPaneInfoTooltip />;
  }

  const isExceeded = props.keywordCount >= props.maxKeywordCount;

  return (
    <HeaderContainer>
      <HeaderText isExceeded={isExceeded}>
        <HeaderTextParagraph>
          {props.keywordCount} Keywords saved (Limit: {props.maxKeywordCount})
        </HeaderTextParagraph>
        {isExceeded && (
          <HeaderTextParagraphWarning>
            Please reduce your list to under {props.maxKeywordCount} to add more
          </HeaderTextParagraphWarning>
        )}
      </HeaderText>
      <KeywordPaneInfoTooltip />
    </HeaderContainer>
  );
};

KeywordPaneHeader.propTypes = {
  keywordCount: PropTypes.number,
  maxKeywordCount: PropTypes.number.isRequired,
};
